export enum LocalStorageKeysEnum {
    appLang = "app-lang",
    token = "token",
}
